import { CheckboxModule } from '../../../shared/component/common/checkbox/checkbox.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorIncomePageComponent } from './error-income.page';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { InputModule } from '../../../shared/component/common/input/input.module';
import { InputCurrencylModule } from '../../../shared/component/common/input-currency/input-currency.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    InputCurrencylModule,
    CheckboxModule,
  ],
  declarations: [ErrorIncomePageComponent]
})
export class ErrorIncomePageModule {}
